<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Precio Servicio - {{ servicio.descripcion }}</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formulario" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Valor desde </mat-label>

                <input
                    matInput
                    type="text"
                    name="desde"
                    formControlName="desde"
                    required
                />
                <span matPrefix>UF&nbsp;</span>

                <mat-error *ngIf="desde.hasError('required')">
                    Debe ingresar el valor desde del servicio
                </mat-error>
                <mat-error *ngIf="desde.hasError('pattern')">
                    El valor desde debe ser numérico
                </mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Valor hasta </mat-label>

                <input
                    matInput
                    type="text"
                    name="hasta"
                    formControlName="hasta"
                    required
                />
                <span matPrefix>UF&nbsp;</span>

                <mat-error *ngIf="hasta.hasError('required')">
                    Debe ingresar el valor hasta del servicio
                </mat-error>
                <mat-error *ngIf="hasta.hasError('noEsMayor')">
                    El valor Hasta no puede ser menor
                </mat-error>
                <mat-error *ngIf="hasta.hasError('pattern')">
                    El valor hasta debe ser numérico
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formulario.value"
            [disabled]="!formulario.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
